import React from 'react';
import { Comment } from 'semantic-ui-react';
import 'semantic-ui-less/definitions/views/comment.less';

export default Comment;
